import { FC, useEffect, useState } from "react";
import { formatCountdown } from "../../utils/time.utils";

type CountdownMessageProps = {
  message: string;
  waitUntil: number;
  onCountdownEnd: () => void;
};

export const CountdownMessage: FC<CountdownMessageProps> = ({
  message,
  waitUntil,
  onCountdownEnd,
}) => {
  const [remainingSeconds, setRemainingSeconds] = useState<number>(() => {
    const now = Math.floor(Date.now() / 1000);
    return Math.max(0, waitUntil - now);
  });

  useEffect(() => {
    if (remainingSeconds <= 0) {
      onCountdownEnd();
      return;
    }

    const interval = setInterval(() => {
      setRemainingSeconds(prev => {
        const next = prev - 1;
        if (next <= 0) {
          clearInterval(interval);
          onCountdownEnd();
        }
        return Math.max(0, next);
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [remainingSeconds, onCountdownEnd]);

  if (remainingSeconds <= 0) return null;

  return (
    <>{message.replace("{countdown}", formatCountdown(remainingSeconds))}</>
  );
};
